var _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgConversation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 1,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 1,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 1,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6579 14.1512L14.658 14.1512L14.658 14.1512L14.6585 14.1515L14.6611 14.153L14.672 14.1594L14.716 14.1851C14.7549 14.2077 14.8123 14.2411 14.8856 14.2834C15.0321 14.368 15.2414 14.4881 15.4911 14.6293C15.8862 14.8525 16.3783 15.126 16.8812 15.394C16.8598 15.3239 16.8388 15.2548 16.8183 15.187C16.6594 14.6624 16.5168 14.1705 16.414 13.8102C16.3625 13.6299 16.3209 13.4821 16.2921 13.379L16.2587 13.2595L16.2499 13.2277L16.2476 13.2193L16.247 13.217L16.2468 13.2164L16.2467 13.2162C16.2467 13.2161 16.2467 13.2161 17.5 12.8708C17.5 12.8708 18.0237 14.7712 18.5026 16.2006C18.5304 16.2837 18.5581 16.3652 18.5855 16.4446C18.7383 16.8871 18.8829 17.2657 19 17.5C19.0982 17.6965 18.9649 17.7297 18.6872 17.6564C18.4619 17.5969 18.1415 17.4672 17.7726 17.2975C17.6702 17.2503 17.564 17.2001 17.4551 17.1474C15.9792 16.4338 14 15.2724 14 15.2724C14 15.2724 12.5 16 10 16C5.02944 16 1 12.866 1 9C1 5.13401 5.02944 2 10 2C14.9706 2 19 5.13401 19 9C19 11.5 17.5 12.8708 17.5 12.8708L16.2467 13.2161L16.0352 12.4483L16.6144 11.919C16.6174 11.9161 16.6228 11.9106 16.6305 11.9027C16.6517 11.8808 16.6895 11.8403 16.7386 11.7818C16.8371 11.6644 16.9781 11.478 17.1217 11.2271C17.4076 10.7277 17.7 9.98068 17.7 9C17.7 6.13709 14.5756 3.3 10 3.3C5.42443 3.3 2.3 6.13709 2.3 9C2.3 11.8629 5.42443 14.7 10 14.7C11.1236 14.7 12.0114 14.5365 12.605 14.3794C12.9017 14.3009 13.1243 14.2242 13.2652 14.1707C13.3355 14.144 13.3854 14.1231 13.4136 14.1109C13.4268 14.1052 13.4353 14.1013 13.439 14.0996L14.0583 13.7992L14.6579 14.1512ZM13.4404 14.099C13.4415 14.0985 13.4413 14.0986 13.4397 14.0993L13.4404 14.099Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgConversation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/conversation.2738b2987bc98da2e12103beb7a16cdb.svg";